(function(){
  function init(){
    var header=document.querySelector('[data-dvn-header]'), mcta=document.querySelector('[data-dvn-mcta]'), form=document.querySelector('[data-dvn-form]');
    var bookVisible=false;
    function onScroll(){var y=window.scrollY;if(header)header.classList.toggle('scrolled',y>8);if(mcta)mcta.classList.toggle('show',y>600&&!bookVisible)}
    if(form&&'IntersectionObserver' in window){new IntersectionObserver(function(e){bookVisible=e[0].isIntersecting;onScroll()}).observe(form)}
    window.addEventListener('scroll',onScroll,{passive:true});onScroll();

    var rv=document.querySelectorAll('.dvn .rv');
    if('IntersectionObserver' in window && !(window.Shopify&&Shopify.designMode)){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
      rv.forEach(function(el,i){el.style.transitionDelay=(i%4)*70+'ms';io.observe(el)});
    } else { rv.forEach(function(el){el.classList.add('in')}) }

    document.querySelectorAll('.dvn [data-machines]').forEach(function(a){a.addEventListener('click',function(){var r=document.querySelector('[data-dvn-m="'+a.dataset.machines+'"]');if(r)r.checked=true})});

    document.querySelectorAll('[data-dvn-date]').forEach(function(d){var t=new Date();t.setMinutes(t.getMinutes()-t.getTimezoneOffset());d.min=t.toISOString().slice(0,10)});

    if(form){
      form.addEventListener('submit',function(e){
        var ok=true;
        form.querySelectorAll('[required]').forEach(function(f){
          var err=f.parentElement.querySelector('.err'),msg='';
          if(!f.value.trim())msg='Required';
          else if(f.type==='email'&&!/^\S+@\S+\.\S+$/.test(f.value))msg='Enter a valid email';
          if(err)err.textContent=msg;if(msg)ok=false;
        });
        if(!ok){e.preventDefault();var first=form.querySelector('.err:not(:empty)');if(first&&first.previousElementSibling)first.previousElementSibling.focus()}
      });
      var msg=form.querySelector('.form-msg');
      if(msg){form.scrollIntoView({block:'center'});msg.focus&&msg.focus()}
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){document.querySelectorAll('.dvn .rv').forEach(function(el){el.classList.add('in')})});
})();
